<template>
  <div>
    <!-- 左边 -->
    <div class="bagrcos">
      <div style="width: 300px; height: 80vh; overflow-y: scroll">
        <a-tree
          v-if="data.length > 0"
          :tree-data="data"
          :defaultExpandAll="true"
          @select="selectNode"
          @rightClick="(a, b) => rightClick(a, b)"
          :selectedKeys="selectedKeys"
        >
          <template #title="{ key: treeKey, title }">
            <a-dropdown :trigger="['contextmenu']">
              <span>{{ title }}</span>
              <template #overlay>
                <a-menu
                  @click="
                    ({ key: menuKey }) => onContextMenuClick(treeKey, menuKey)
                  "
                >
                  <a-menu-item key="1">新增</a-menu-item>
                  <a-menu-item key="2">删除</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </a-tree>
      </div>
      <!-- 右边 -->
      <div class="add_form">
        <h2 class="tip-icon">{{ title }}</h2>
        <br />
        <a-form-model
          ref="ruleForm"
          :model="formState"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="部门名称" prop="deptName">
                <a-input
                  placeholder="请输入部门名称"
                  v-model="formState.deptName"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="部门编号" prop="deptCode">
                <a-input
                  placeholder="请输入部门编号"
                  v-model="formState.deptCode"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="状态" prop="status">
                <a-select
                  show-search
                  v-model="formState.status"
                  placeholder="请选择部门状态"
                >
                  <a-select-option
                    v-for="item in deptstatus"
                    :key="item.value"
                    :value="item.value"
                    >{{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="父级" prop="parentid">
                <a-tree-select
                  :disabled="formState.parentId == '0' ? true : false" 
                  v-if="deptIddata.length > 0"
                  v-model="formState.parentId"
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="deptIddata"
                  placeholder="部门"
                  allow-clear
                  tree-default-expand-all
                >
                </a-tree-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="部门类型" prop="deptType">
                <a-select
                  show-search
                  v-model="formState.deptType"
                  placeholder="请选择部门类型"
                >
                  <a-select-option
                    v-for="item in deptType"
                    :key="item.value"
                    :value="item.value"
                    >{{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="排序号" prop="orderNum">
                <a-input
                  type="number"
                  placeholder="请输入排序号"
                  v-model="formState.orderNum"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="remark">
            <a-col :span="24">
              <a-form-model-item label="备注" prop="remark">
                <a-textarea v-model="formState.remark" style="height: 80px" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <a-row style="margin-left: 10%">
          <a-col :span="24">
            <a-button type="primary" @click="handleOk"
              ><span>保存</span></a-button>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import {
  deptAdd,
  deptQuery,
  deptDelete,
  deptUpdate,
  deptId,
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";

export default {
  data() {
    return {
      disabled: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      deptIddata: [],
      data: [],
      values: "",
      menuData: [],
      initData: [],
      title: "部门编辑",
      updateId: "1",
      //默认选中节点
      selectedKeys: ["1"],

      formState: {
        deptName: "",
        deptCode: "",
        deptType: undefined,
        parentId: "",
        status: undefined,
        orderNum: "",
        remark: "",
      },
      // 表单验证
      rules: {
        deptCode: [
          {
            required: true,
            message: "请输入部门编号",
            trigger: "change",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        deptName: [
          {
            required: true,
            message: "请输入部门名称",
            trigger: "change",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        parentId: [
          {
            required: true,
            message: "请选择父部门",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择部门状态",
            trigger: "blur",
          },
        ],
        deptType: [
          {
            required: true,
            message: "请选择部门类型",
            trigger: "blur",
          },
        ],
        remark: [
          {
            max: 100,
            message: "备注长度不能超过100",
          },
        ],
        orderNum: [
          {
            max: 8,
            message: "长度不能超过8",
          },
        ],
      },
      deptstatus: [],
      deptType: [],
    };
  },
  mounted() {
    const myremark = document
      .querySelector(".remark")
      .querySelector(".ant-form-item-label");
    const myrInput = document
      .querySelector(".remark")
      .querySelector(".ant-form-item-control-wrapper");
    myremark.classList.add("ant-col-2"); // 添加 my-class 类
    myremark.classList.remove("ant-col-5"); // 添加 my-class 类
    myrInput.classList.add("ant-col-22"); // 添加 my-class 类
    myrInput.classList.remove("ant-col-18"); // 添加 my-class 类
    const myremark1 = document
      .querySelector(".remark")
      .querySelector(".ant-col-2");
    myremark1.style.width = "10.333333%";

    const myrInput1 = document
      .querySelector(".remark")
      .querySelector(".ant-col-22");
    myrInput1.style.width = "87.666667%";

    this.searchList();
    this.QueryList();

    //字典
    DictionaryService.getAllNeedDic(["DEPT_STATUS", "DEPT_TYPE"]).then(
      (res) => {
        this.deptstatus = DictionaryService.getOptions("DEPT_STATUS");
        this.deptType = DictionaryService.getOptions("DEPT_TYPE");

        this.values = this.menuStateData;
      }
    );
  },

  methods: {
    QueryList() {
      let pageParam = {
        pageNum: 0,
        pageSize: 0,
        orderBy: "",
      };
      deptQuery({ pageParam: pageParam })
        .then((res) => {
          res.content.forEach((item) => {
            const hasIds = item.id;
            if (hasIds == -1) {
              item["disabled"] = true;
            } else {
              item["disabled"] = false;
              return;
            }

            if (item.id == "1") {
              this.formState.deptCode = item.deptCode;
              this.formState.deptName = item.deptName;
              this.formState.deptType = item.deptType;
              this.formState.orderNum = item.orderNum;
              this.formState.parentId = item.parentId;
              this.formState.remark = item.remark;
              this.formState.status = item.status;
            }
          });
          this.getTreemenu(res.content, 0);
          this.getTree(res.content, 0);
        })
        .then((res) => {
          this.traverse(this.deptIddata);
        });
    },
    // 树型菜单列表获取
    getTree(data, parentId) {
      var treeMenu = [];
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        if (data[i].parentId == parentId) {
          var newTree = {
            key: node.id,
            title: node.deptName,
            value: node.id,
            parentid: node.parentId,
            children: this.getTree(data, node.id),
          };
          treeMenu.push(newTree);
        }
      }
      this.deptIddata = treeMenu;
      return treeMenu;
    },

    // 菜单列表查询
    searchList() {
      let pageParam = {
        pageNum: 0,
        pageSize: 0,
        orderBy: "",
      };
      deptQuery({ pageParam: pageParam }).then((res) => {
        if (this.selectedKeys.includes("1")) {
          this.disabled = true;
          res.content.forEach((item) => {
            if (item.id == "1") {
              this.formState.deptCode = item.deptCode;
              this.formState.deptName = item.deptName;
              this.formState.deptType = item.deptType;
              this.formState.orderNum = item.orderNum;
              this.formState.parentId = item.parentId;
              this.formState.remark = item.remark;
              this.formState.status = item.status;
            }
          });
        }
        // }

        this.initData = res.content;
        this.menuData = res.content;
        this.getTreemenu(res.content, 0);
      });
    },
    // 树型菜单列表获取
    getTreemenu(data, parentId) {
      var treeMenu = [];
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        if (data[i].parentId == parentId) {
          var newTree = {
            key: node.id,
            title: node.deptName,
            value: node.id,
            children: this.getTreemenu(data, node.id),
          };
          treeMenu.push(newTree);
        }
      }
      this.data = treeMenu;
      return treeMenu;
    },
    handleChange(val) {
    },
    // 添加菜单
    addMenu() {
      this.visible = true;
    },
    //重置
    reset() {
      this.$refs["ruleForm"].resetFields();
    },
    handleOk(e) {
      //弹窗确定
      if (this.title === "部门新增") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            deptAdd({
              deptCode: this.formState.deptCode,
              deptName: this.formState.deptName,
              deptType: this.formState.deptType,
              orderNum: this.formState.orderNum,
              parentId: this.formState.parentId,
              status: this.formState.status,
              remark: this.formState.remark,
            }).then(
              (res) => {
                if (res.code == "0000") {
                  this.$message.success("操作成功");
                  location.reload();
                  this.searchList();
                  this.QueryList();
                  this.$refs["ruleForm"].resetFields();
                } else {
                  // this.success(res.message);
                }
              },
              (err) => {}
            );
          }
        });
      } else {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            deptUpdate({
              id: this.updateId,
              deptCode: this.formState.deptCode,
              deptName: this.formState.deptName,
              deptType: this.formState.deptType,
              orderNum: this.formState.orderNum,
              parentId: this.formState.parentId,
              status: this.formState.status,
              remark: this.formState.remark,
            }).then(
              (res) => {
                if (res.code == "0000") {
                  this.$message.success("操作成功");
                  location.reload();
                  this.searchList();

                  this.QueryList();
                } else {
                  // this.success(res.message);
                }
              },
              (err) => {}
            );
          }
        });
      }
    },

    handleCancel() {
      //关闭弹窗
      this.$emit("close");
      this.$refs["ruleForm"].resetFields();
    },

    onContextMenuClick(treeKey, menuKey) {
      this.selectedKeys.splice(0);
      this.selectedKeys.push(treeKey);
      let id = treeKey;
      if (menuKey == "1") {
        this.title = "部门新增";
        this.$refs["ruleForm"].resetFields();
        this.formState.parentId = treeKey;
      } else if (menuKey == "2") {
        this.$confirm({
          title: "确定是否删除?",
          okText: "是",
          cancelText: "否",
          onOk: () => {
            let obj = {
              id: id,
            };
            deptDelete(obj).then(
              (res) => {
                this.searchList();
                this.selectedKeys.splice(0);

                this.selectedKeys.push("1");
                this.searchList();

                this.QueryList();
                // this.$refs["ruleForm"].resetFields();
              },
              (err) => {
              }
            );
          },
          onCancel: () => {},
        });
      } else {
        this.title = "部门编辑";
        this.menuData.forEach((item) => {

          if (item.id == treeKey) {
            deptId({ id: item.id }).then((res) => {
              this.formState.deptCode = res.content.deptCode;
              this.formState.deptName = res.content.deptName;
              this.formState.deptType = res.content.deptType;
              this.formState.orderNum = res.content.orderNum;
              this.formState.parentId = res.content.parentId;
              this.formState.status = res.content.status;
              this.formState.remark = res.content.remark;
            });
          }
        });
      }
    },

    // 左键单机树节点
    selectNode(key, e) {
      let keys = [e.node.eventKey];
      // this.formState.parentid=key
      this.title = "部门编辑";

      this.updateId = keys[0];
      this.selectedKeys.splice(0);
      this.selectedKeys = keys;
      this.getTree(this.menuData, 0);
      this.searchOne(keys);
      this.traverse(this.deptIddata);
    },

    traverse(data) {
      for (let i = 0; i < data.length; i++) {
        var node = data[i];
        if (node.key == this.updateId) {
          node.disabled = true;
          this.initData = node;
          this.againTraverse(this.initData.children);
        }
        this.traverse(data[i].children);
      }
      this.deptIddata = data;
    },
    againTraverse(node) {
      for (let item of node) {
        item.disabled = true;
        if (item.children && item.children.length) {
          this.againTraverse(item.children);
        }
      }
      return node;
    },
    rightClick({ event, node }) {
      this.title = "部门编辑";
      this.updateId = node._props.eventKey;
      this.selectedKeys.splice(0);
      this.selectedKeys.push(node._props.eventKey);
      this.searchOne(node._props.eventKey);
      this.getTree(this.menuData, 0);
      this.traverse(this.deptIddata);
    },
    //查询单个菜单
    searchOne(treeid) {
      this.menuData.forEach((item) => {
        if (item.id == treeid) {
          deptId({ id: item.id }).then((res) => {
            this.formState.deptCode = res.content.deptCode;
            this.formState.deptName = res.content.deptName;
            this.formState.deptType = res.content.deptType;
            this.formState.orderNum = res.content.orderNum;
            this.formState.parentId = res.content.parentId;
            this.formState.status = res.content.status;
            this.formState.remark = res.content.remark;
          });

          /* if(item.deptName == '博英科技') {
            this.formState.parentId = '博英科技'
          } */
          if (item.deptName == "博英科技") {
            this.disabled = true;
          } else {
            this.disabled = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import url("../../../common/css/antd-table.less");

.ant-btn-primary{
    background: rgba(255, 255, 255, 1);
    color: rgba(22, 130, 139, 1);
}

.ant-btn-primary:hover, .ant-btn-primary:focus{
    background: rgba(22, 130, 139, 1);
	border-color:rgba(22, 130, 139, 1);
	color: rgba(255, 255, 255, 1);
}
.appraisement-box {
  .header-edit {
    padding: 0 3%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .edit {
      display: flex;
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
}

.bagrcos {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  margin-top: 10px;

  .add_form {
    flex: 1;

    h2 {
      font-size: medium;
    }

    margin-left: 100px;
  }
}

.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected{
  background-color: rgb(22,130,139,0.4);
}
</style>
